import ApplicationController from "application_controller.js";

export default class extends ApplicationController {
  debug = false;

  static values = {
    offset: { type: Number, default: 0 },
    behavior: { type: String, default: "smooth" },
  };

  scroll() {
    window.scrollTo({ top: this.offsetValue, behavior: this.behaviorValue });
  }
}
